import { apiClient } from "./client";
import type {
  GetCreditBalanceResponse,
  GetSubscriptionResponse,
  ListTransactionsResponse,
  SubscriptionStatus,
} from "./types";

// Mirrors BillingService RPCs in console/proto/billing.proto. All read-only
// (billing state is Stripe-synced server-side; there is no mutating RPC
// exposed here).

export async function getSubscription(organizationId: string): Promise<GetSubscriptionResponse> {
  const { data } = await apiClient.get<GetSubscriptionResponse>(
    `/organizations/${organizationId}/subscription`,
  );
  return data;
}

export async function listTransactions(
  organizationId: string,
  params?: { limit?: number; offset?: number },
): Promise<ListTransactionsResponse> {
  const { data } = await apiClient.get<ListTransactionsResponse>(
    `/organizations/${organizationId}/transactions`,
    { params },
  );
  return data;
}

export async function getCreditBalance(
  organizationId: string,
): Promise<GetCreditBalanceResponse> {
  const { data } = await apiClient.get<GetCreditBalanceResponse>(
    `/organizations/${organizationId}/credit-balance`,
  );
  return data;
}

export const SUBSCRIPTION_STATUS_LABELS: Record<SubscriptionStatus, string> = {
  SUBSCRIPTION_STATUS_UNSPECIFIED: "Unknown",
  SUBSCRIPTION_STATUS_TRIALING: "Trialing",
  SUBSCRIPTION_STATUS_ACTIVE: "Active",
  SUBSCRIPTION_STATUS_PAST_DUE: "Past Due",
  SUBSCRIPTION_STATUS_CANCELED: "Canceled",
  SUBSCRIPTION_STATUS_UNPAID: "Unpaid",
  SUBSCRIPTION_STATUS_INCOMPLETE: "Incomplete",
  SUBSCRIPTION_STATUS_INCOMPLETE_EXPIRED: "Incomplete (Expired)",
};

export function subscriptionBadgeVariant(
  status: SubscriptionStatus,
): "success" | "info" | "danger" | "warning" | "default" {
  switch (status) {
    case "SUBSCRIPTION_STATUS_ACTIVE":
      return "success";
    case "SUBSCRIPTION_STATUS_TRIALING":
      return "info";
    case "SUBSCRIPTION_STATUS_PAST_DUE":
    case "SUBSCRIPTION_STATUS_UNPAID":
      return "warning";
    case "SUBSCRIPTION_STATUS_CANCELED":
    case "SUBSCRIPTION_STATUS_INCOMPLETE_EXPIRED":
      return "danger";
    default:
      return "default";
  }
}
